// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"1b3e0dcd","243":"b5430111","619":"e0566fcc","678":"eb40c4f7","834":"9b1126b1"}[chunkId] + ".chunk.css";
};